import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

// Lazy load components
const HomePage = lazy(() => import('../pages/home/page'));
const LoginPage = lazy(() => import('../pages/auth/login/page'));
const AdminLoginPage = lazy(() => import('../pages/auth/admin-login/page'));
const RegisterPage = lazy(() => import('../pages/auth/register/page'));
const UserDashboard = lazy(() => import('../pages/dashboard/user/page'));
const AdminDashboard = lazy(() => import('../pages/dashboard/admin/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/register',
    element: <RegisterPage />
  },
  {
    path: '/dashboard',
    element: <UserDashboard />
  },
  {
    path: '/dashboard/user',
    element: <UserDashboard />
  },
  {
    path: '/admin/login',
    element: <AdminLoginPage />
  },
  {
    path: '/admin/dashboard',
    element: <AdminDashboard />
  },
  {
    path: '/dashboard/admin',
    element: <AdminDashboard />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
